export default __webpack_public_path__ + "static/media/Robot_04.440df401.png";